import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pm-listing-search',
  templateUrl: './pm-listing-search.component.html',
  styleUrls: ['./pm-listing-search.component.scss'],
})
export class PmListingSearchComponent implements OnInit {
  @Input() value = '';
  @Output() searchingText = new EventEmitter<InputEvent>();
  @Output() openFilter = new EventEmitter<null>();
  @Output() updateFilter = new EventEmitter<{ id: string; value: string }>();
  constructor() {}

  ngOnInit(): void {}

  searchText(event: InputEvent): any {
    this.searchingText.emit(event);
  }

  _openFilter(): any {
    this.openFilter.emit();
  }

  _updateFilter(id: string, value: string): any {
    this.updateFilter.emit({ id, value });
  }
}
